import * as React from 'react';
import { FilterPanel } from './filter-panel';
import { Filter } from '../types';
import { FilterError } from './filter-types/filter-error/filter-error';
import { createFilterConfigurations } from 'app/components/filters/filters-panel/create-filter-configurations';
import { getFilterSelectedOptionsLength } from 'app/components/filters/filters-panel/selected-options-length';
import { caseTypeDomainId } from 'app/components/filters/filters-panel/constants';
import { AddFilters } from 'app/components/filters/add-filters/add-filters';
import { createFilterValidation } from 'app/components/filters/filters-panel/filter-validation';
import { getSelectedOptionsIds, createFilteredValues, getCategoryOptionsParams } from 'app/area/filters/filters-mapping';
import styles from './filter-panel.scss';
import { getOptionTypeValue } from 'app/components/filters/filters-panel/option-type-value';
import { FiltersViewProps } from 'app/components/filters/filters-panel/filters-view-props';

export class FiltersPanel extends React.Component<FiltersViewProps> {
  private getCaseTypeSelectedOptionsIds = (domainId: number) => {
    const ids = this.props.editingValues && domainId !== caseTypeDomainId &&
      getSelectedOptionsIds(this.props.editingValues, caseTypeDomainId);
    return ids && ids.length > 0 ? { applicationId: ids } : {};
  }

  public componentDidUpdate(prevProps: FiltersViewProps) {
    const hasChangesEditingValues =  this.props.editingValues !== prevProps.editingValues;
    const hasChangesValidations =  this.props.validateFilters !== prevProps.validateFilters;

    const shouldValidate = this.props.favouriteDefinition ? hasChangesEditingValues :
      (hasChangesValidations || hasChangesEditingValues) && this.props.validateFilters;

    if (shouldValidate) {
      this.validateFilters();
    }
  }

  private validateFilters = () => {
    const validationConfig = this.props.filtersDefinition.reduce((memo, f) => {
      const validation = createFilterValidation(f.advancedSearchType);

      return validation ? [
        ...memo,
        validation(f)
      ] : memo;
    }, []);

    this.props.validate(validationConfig);
  }

  private renderDomainFilters = (filter: Filter) => {
    const filterConfiguration = createFilterConfigurations(filter.advancedSearchType);

    if (filterConfiguration && filterConfiguration.component) {
      const FilterComponent = filterConfiguration.component;

      const filteredValues = this.props.editingValues && createFilteredValues(this.props.editingValues, this.props.validation);
      const optionTypeValue = getOptionTypeValue(filter);
      const count =  getFilterSelectedOptionsLength(filter.id, filteredValues, filterConfiguration.postfix, optionTypeValue);

      return <FilterPanel
        key={filter.id + '_filter_panel'}
        id={filter.id}
        filter={filter}
        count={count}
        isOpen={filter.isOpen}
        translate={this.props.translation}
        onFilterMenuOption={this.props.onFilterMenuOption}
        onChange={this.props.setOpenState}
        onRemove={this.props.onRemove}
        added={filter.added}>
        <FilterComponent
          filterDomain={filter}
          initialValue={filter.initialValue}
          optionsEndpoint={filterConfiguration.optionsEndpoint?.(filter.domain)}
          categoryOptionsEndpoint={filterConfiguration.categoryOptionsEndpoint?.(filter.domain)}
          simpleFormComponent={this.props.SimpleField}
          translation={this.props.translation}
          userProfile={this.props.userProfile}
          optionsParams={this.getCaseTypeSelectedOptionsIds(filter.domain)}
          onFilterOptionType={this.props.onFilterOptionType}
          displayCategories={filterConfiguration.displayCategories}
          categoryOptionsParams={getCategoryOptionsParams(filter.advancedSearchType)}
        />
      </FilterPanel>;
    } else {
      return <div key={filter.domain}>
        <FilterError
          label={filter.label}
          message={this.props.translation.filters_error_message} />
      </div>;
    }
  }

  private createRows(filters: any) {
    const lgBreakpoint = 1200;
    const colClasses = this.props.width > lgBreakpoint ? 'col-12 col-xl-4' : 'col-12 col-lg-6';
    const cols = this.props.width > lgBreakpoint ? 3 : 2;
    const colContainer = [];

    for (let i = 0; i < cols; i++) {
      const col = <div key={i} className={colClasses}>
        {filters.filter((item, index) => { return index % cols === i; })}
      </div>;
      colContainer.push(col);
    }

    return (
      <div className="row">
        {colContainer}
      </div>
    );
  }

  public render() {
    const { filtersDefinition, translation, locale, options, onAdvancedSearchFields, width, onAddFilters } = this.props;
    const filters = filtersDefinition
      .filter(filter => filter.advancedSearchType !== 0)
      .map(this.renderDomainFilters);

    return (<div className={`${styles.filtersPanel} filters-panel`}>
      {width ? this.createRows(filters) : filters}
      {!!onAddFilters && <AddFilters
        translation={translation}
        locale={locale}
        options={options}
        onAddNewFilters={onAddFilters}
        onLoadAdvancedSearchFields={onAdvancedSearchFields} />}
    </div>);
  }
}
